import { selectEventsByEventLogType } from 'store/queries/bolt-api/contacts/selectors.ts'
import { EventLogType } from 'types/eventLog.ts'
import dayjs from 'dayjs'
import { TriggerSalesSurveyParams } from './types.ts'
import { AppStore } from 'store/app/types.ts'

/**
 * Triggers the sales survey based on the last active push billing contract and event data.
 * @param {TriggerSalesSurveyParams} params
 */
export const checkCanTriggerSalesSurvey = ({
  lastActivePushBillingContract,
  loading,
  eventData
}: TriggerSalesSurveyParams): AppStore['salesSurvey'] => {
  if (!loading && lastActivePushBillingContract) {
    const respondedSurveys = selectEventsByEventLogType({ events: eventData, type: EventLogType.SURVEY_RESPONDED })
    const subscribedSinceJune2025 = dayjs(lastActivePushBillingContract.serviceContracts.electricity.detail.subscriptionDate).isAfter(
      '2025-06-01'
    )
    const subscribedLessThanYearAgo = dayjs(lastActivePushBillingContract.serviceContracts.electricity.detail.subscriptionDate).isAfter(
      dayjs().subtract(1, 'year')
    )

    // Trigger the sales survey if the user has not responded to a survey and subscribed less than a year ago
    if (subscribedSinceJune2025 && subscribedLessThanYearAgo && respondedSurveys.length === 0) {
      const manuallyClosedSurveys = selectEventsByEventLogType({ events: eventData, type: EventLogType.SURVEY_CLOSED })

      return {
        show: manuallyClosedSurveys.length < 3 ? 'intro' : false,
        isEligible: true,
        contractId: lastActivePushBillingContract.contractNumber
      }
    }
  }

  return {
    show: false,
    isEligible: false,
    contractId: null
  }
}
